var map = {
	"./modules/about/about.module": "./src/app/modules/about/about.module.ts",
	"./modules/achievers/achievers.module": "./src/app/modules/achievers/achievers.module.ts",
	"./modules/admission/admission.module": "./src/app/modules/admission/admission.module.ts",
	"./modules/blogs/blogs.module": "./src/app/modules/blogs/blogs.module.ts",
	"./modules/calendar/calendar.module": "./src/app/modules/calendar/calendar.module.ts",
	"./modules/gallery/gallery.module": "./src/app/modules/gallery/gallery.module.ts",
	"./modules/infra/infra.module": "./src/app/modules/infra/infra.module.ts",
	"./modules/life/life.module": "./src/app/modules/life/life.module.ts",
	"./modules/media/media.module": "./src/app/modules/media/media.module.ts",
	"./modules/rules/rules.module": "./src/app/modules/rules/rules.module.ts",
	"./modules/testimonial/testimonial.module": "./src/app/modules/testimonial/testimonial.module.ts",
	"./modules/video/video.module": "./src/app/modules/video/video.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;